export default Object.freeze({
  baseURL: 'https://www.linguaprocenter.com:443/api/'
})
